import React, { memo, useRef, useEffect } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';

export default memo(function IDXNumberStockChart(props) {
    const { numberUp, numberDown, numberNoChange } = props;
    //
    const { t } = useTranslation();
    //
    const refChart = useRef(null);
    //
    const _getChartOptions = () => {
        const _datas = [
            { value: numberUp, name: t("tang"), itemStyle: { color: '#00E500' } },
            { value: numberDown, name: t("giam"), itemStyle: { color: '#DB3624' } },
            { value: numberNoChange, name: t("khongDoi"), itemStyle: { color: '#FFD500' } }
        ];
        //
        return {
            useUTC: false,
            textStyle: {
                fontFamily: "tahoma, 'Be Vietnam Pro'",
            },
            tooltip: {
                trigger: "item",
                axisPointer: {
                    type: "shadow",
                },
                textStyle: {
                    // lineHeight: 30,
                    color: '#fff',
                    fontSize: 12,
                    lineHeight: '21px'
                }, 
                padding: [5, 9],
                backgroundColor: 'rgba(47, 62, 76, 0.9)', 
                borderColor: 'transparent',
                confine: true,
                // formatter: '{b}: {c} ({d}%)',
                formatter: function (params) {
                    //console.log(params);
                    // borderColor: undefined
                    // color: "#00E500"
                    // componentIndex: 0
                    // componentSubType: "pie"
                    // componentType: "series"
                    // data: {value: '237', name: 'Increase', itemStyle: {…}}
                    // dataIndex: 0
                    // dataType: undefined
                    // dimensionNames: []
                    // encode: {value: Array(1)}
                    // marker: "<span style=\"display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#00E500;\"></span>"
                    // name: "Increase"
                    // percent: 75
                    // seriesId: "\u0000series\u00000\u00000"
                    // seriesIndex: 0
                    // seriesName: "series\u00000"
                    // seriesType: "pie"
                    // value: "237"

                    var colorSpan = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + params.color + '"></span>';
                    let rez = '<p>' + colorSpan + '<span>' + params.name + ": " + params.value + ' (' + params.percent + '%)</span></p>';
                    return rez;
                },
            },
            series: [
                {
                    type: 'pie',
                    data: _datas,
                    avoidLabelOverlap: false,
                    left: "0",
                    right: "0",
                    top: "0",
                    bottom: "0",                    
                    label: {
                        show: true,
                        color: '#fff',
                        formatter: '{b} ({c})',
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        }
                    },
                },
            ],
        }
    }
    //
    useEffect(() => {
        if(refChart && refChart.current)
        {
            refChart.current.getEchartsInstance().setOption(_getChartOptions());
        }
    });
    //
    return (
        <ReactECharts style={{width: '100%', height: '100%', ...props.style}}
            ref={refChart}
            lazyUpdate={true}
            option={_getChartOptions()}
        />
    )
})
